import { render, staticRenderFns } from "./LanguageTest.vue?vue&type=template&id=321aa48d&"
import script from "./LanguageTest.vue?vue&type=script&lang=js&"
export * from "./LanguageTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports